import type { Entry, UnresolvedLink } from 'contentful';

import type { CompositionItem, Config, Model } from '../components/resolver/config';
import { isResolvedLinkEntry } from './isResolvedLinkEntry';

export type MapEntry = (entry: Entry | UnresolvedLink<'Entry'> | null | undefined) => CompositionItem | null;
export type Transform = (entry: Entry, map: MapEntry) => Model['props'] | null;
export type Transforms = Partial<Record<string, Transform>>;

export function mapEntry(entry: Parameters<MapEntry>[0], transforms: Transforms): CompositionItem | null {
    if (!isResolvedLinkEntry(entry)) return null;
    const contentType = entry.sys.contentType.sys.id;
    const transform = transforms[contentType];
    if (!transform) return entry;

    const props = transform(entry, child => mapEntry(child, transforms));
    return props === null ? null : { contentType: contentType as keyof Config, props };
}

export function mapEntries(
    entries: readonly Parameters<MapEntry>[0][] | undefined,
    transforms: Transforms
): CompositionItem[] {
    return (entries ?? []).map(entry => mapEntry(entry, transforms)).filter(entry => entry !== null);
}
